import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'store';
import { emoloyeeAuditLogSelector } from 'store/selectors/audit-log-selector';
import { getEmployeeAuditLogDetailsAction } from 'store/actions/audit-log-actions';
import { useEffect, useState } from 'react';
import {
  AUDITING__VIEW_HISTORY,
  AUDITING__NO_ITEMS_FOUND,
  AUDITING__TABLE_HEADER_NAME,
  AUDITING__TABLE_HEADER_DATE,
  AUDITING__TABLE_HEADER_CHANGELOG,
} from 'translations/constants';
import { AuditModel, LogsDialogProps } from './types';
import { AuditRow } from './AuditRow';

export const LogsDialog: React.FC<LogsDialogProps> = ({ open, onClose, employeeName, employeeId, companyId }) => {
  const [t] = useTranslation();
  const dispatch = useAppDispatch();
  const auditLogDetails = useAppSelector(emoloyeeAuditLogSelector);
  const [auditLogs, setAuditLogs] = useState<AuditModel[]>([]);

  useEffect(() => {
    if (auditLogDetails) {
      setAuditLogs(auditLogDetails);
    }
  }, [auditLogDetails]);

  useEffect(() => {
    if (open) {
      setAuditLogs([]);
      dispatch(getEmployeeAuditLogDetailsAction({ employeeId, companyId }));
    }
  }, [companyId, employeeId, open, dispatch]);

  const onModalClose = () => {
    setAuditLogs([]);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onModalClose} fullWidth maxWidth="md">
      <DialogTitle>{`${t(AUDITING__VIEW_HISTORY)} - ${employeeName}`}</DialogTitle>
      <DialogContent dividers>
        <TableContainer component={Paper} variant="outlined">
          <Table size="medium" aria-label="audit log table">
            <TableHead>
              <TableRow>
                <TableCell>{t(AUDITING__TABLE_HEADER_NAME)}</TableCell>
                <TableCell>{t(AUDITING__TABLE_HEADER_DATE)}</TableCell>
                <TableCell>{t(AUDITING__TABLE_HEADER_CHANGELOG)}</TableCell>
                <TableCell align="right" width={56} />
              </TableRow>
            </TableHead>
            <TableBody>
              {auditLogs.map(a => (
                <AuditRow key={a.id} audit={a} />
              ))}
              {auditLogs?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4}>
                    <Typography color="text.secondary">{t(AUDITING__NO_ITEMS_FOUND)}</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onModalClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
